import { render } from "./ComplianceSubmissionDialog.vue?vue&type=template&id=21f4fa19"
import script from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceSubmissionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__